export default __webpack_public_path__ + "images/hr-faded-top.png";